export enum AuthType {
  Classic = 'Classic', // Auth0
  Cloud = 'Cloud',     // Identity
}
